import { MenuIcon } from 'lucide-react';
import React from 'react';
import styled from 'styled-components';
import { type FileData } from '../types';
import CodeViewer from './CodeViewer';
import Sidebar from './Sidebar';

interface LayoutProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  files: FileData[];
  selectedFile: FileData | null;
  onFileSelect: (file: FileData) => void;
  title?: React.ReactNode;
  replacements?: Record<string, string>;
}

// Styled components
let Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #111;
  color: #ddd;
`;

let Header = styled.header`
  height: 3.5rem;
  background-color: #111;
  border-bottom: 1px solid #333;
  display: flex;
  align-items: center;
  padding: 0 1rem;
`;

let ToggleButton = styled.button`
  margin-right: 1rem;
  background: transparent;
  transition: background-color 0.2s ease-in-out;
  color: #ddd;
  border: none;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease-in-out;

  svg {
    height: 16px;
    width: 16px;
  }

  &:hover {
    background-color: #333;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

let TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

let Title = styled.span`
  font-size: 1.25rem;
  font-weight: 600;
`;

let Body = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

let Main = styled.main`
  flex: 1;
  overflow: hidden;
`;

let Layout: React.FC<LayoutProps> = ({
  sidebarOpen,
  toggleSidebar,
  files,
  selectedFile,
  onFileSelect,
  title,
  replacements
}) => {
  return (
    <Container>
      <Header>
        <ToggleButton onClick={toggleSidebar} aria-label="Toggle sidebar">
          <MenuIcon size={20} />
        </ToggleButton>
        <TitleWrapper>
          <Title>{title}</Title>
          {/* {selectedFile && <FileName>{selectedFile.name}</FileName>} */}
        </TitleWrapper>
      </Header>

      <Body>
        <Sidebar
          isOpen={sidebarOpen}
          files={files}
          onFileSelect={onFileSelect}
          selectedFile={selectedFile}
        />
        <Main>
          <CodeViewer
            file={selectedFile}
            key={selectedFile?.id ?? '.'}
            replacements={replacements || {}}
          />
        </Main>
      </Body>
    </Container>
  );
};

export default Layout;
